var React = require('react');

function Camera (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M58 16H38L28 28H16C13.8783 28 11.8434 28.8429 10.3431 30.3431C8.84285 31.8434 8 33.8783 8 36V72C8 74.1217 8.84285 76.1566 10.3431 77.6569C11.8434 79.1571 13.8783 80 16 80H80C82.1217 80 84.1566 79.1571 85.6569 77.6569C87.1571 76.1566 88 74.1217 88 72V36C88 33.8783 87.1571 31.8434 85.6569 30.3431C84.1566 28.8429 82.1217 28 80 28H68L58 16Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M48 64C54.6274 64 60 58.6274 60 52C60 45.3726 54.6274 40 48 40C41.3726 40 36 45.3726 36 52C36 58.6274 41.3726 64 48 64Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Camera.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Camera;

Camera.default = Camera;
